import React, { Component } from "react";
import { connect } from "react-redux";
import { Start } from "../../components";
import "./styles.css";
import { switchProgram } from "../../actions/user";

class StartSection extends Component {
  render() {
    let { selectedProgram, subscribedPrograms, switchProgram, } = this.props;
    selectedProgram = subscribedPrograms.find(
      program => program._id === selectedProgram
    );
   

    if (!selectedProgram) return null;

    return (
      <div className="start-section">

        <h1>Моите позитивни програми</h1>

        <div className="nav-page">
          {subscribedPrograms.map(program => (
            <a
              key={program._id}
              href="javascript:void(0)"
              className={selectedProgram._id === program._id ? "active" : ""}
              onClick={() => switchProgram(program._id)}
            >
              {program.title}
            </a>
          ))}
        </div>

        <div className="row">

          <div className="col content-col">

            <div className="pic">
              <img src="/imgs/profile.jpg" alt="" />
            </div>

            <h2>{selectedProgram.title}</h2>
            <p>{selectedProgram.description}</p>

          </div>

          <div className="col start-bttn-col">

            <Start />

          </div>


        </div>
      </div>
    );
  }
}

const mstp = state => ({
  selectedProgram: state.user.payload.selectedProgram,
  subscribedPrograms: state.user.payload.subscribedPrograms
});

const mdtp = dispatch => ({
  switchProgram: id => dispatch(switchProgram({ _id: id }))
});

export default connect(
  mstp,
  mdtp
)(StartSection);



// WEBPACK FOOTER //
// ./src/components/StartSection/StartSection.js